import jQuery from 'jquery/dist/jquery.min'
import { initAll as GOVUKFrontendInitAll} from 'govuk-frontend/dist/govuk/govuk-frontend.min.js'
import { initAll as DMPFrontendInitAll } from 'digitalmarketplace-frontend/dist/digitalmarketplace/digitalmarketplace-frontend.min.js'
import { initLiveSearch } from './_live-search'

window.$ = window.jQuery = jQuery

GOVUKFrontendInitAll()
DMPFrontendInitAll()
initLiveSearch()
